export const enableHoneypot = (form: any) => {
  if (form) {
    const btn = form.querySelector('.button');

    const honeypotIsTruthy = () => {
      const honeypot = form.querySelector('[name="honeypot"]');

      return !!honeypot?.value;
    };

    btn?.addEventListener('click', e => {
      if (honeypotIsTruthy()) {
        e.preventDefault();

        return false;
      }
    });
  }
};
